import React from 'react';
import { SFPeopleOption, SFPeoplePicker } from 'sfui';
import { AppOptionsContext, Area } from 'ui-smartforce-settings';

const formatOptionsToPeoplePicker = (options: Area[]): SFPeopleOption[] => {
  return options.map((o: Area) => {
    return {
      name: o.name,
      acronym: o.acronym,
      asyncObject: { id: o.id }
    };
  });
};

const getOptionSelected = (option: SFPeopleOption, value: SFPeopleOption) => {
  return option.name === value.name;
};

export interface AreaSelectProps {
  label: string;
  value: SFPeopleOption[];
  showStateMandated?: boolean;
  showMissingInformation?: boolean;
  onChange: (value: SFPeopleOption[]) => void;
}

export const AreaSelect = ({
  showStateMandated = false,
  showMissingInformation = false,
  ...props
}: AreaSelectProps): React.ReactElement<AreaSelectProps> => {
  const { areas } = React.useContext(AppOptionsContext);

  return (
    <SFPeoplePicker
      label={props.label}
      isAsync={false}
      options={formatOptionsToPeoplePicker(areas)}
      multiple={true}
      value={props.value}
      getOptionSelected={getOptionSelected}
      onChange={props.onChange}
      showStateMandated={showStateMandated}
      showMissingInformation={showMissingInformation}
    />
  );
};
